module.exports = __webpack_public_path__ + "static/media/group_women.5cd76b76.jpg";